/**
 * „Parašyk mums" — the two warnings, and they say different things on purpose.
 *
 * These used to be `PERSONALIZATION_PRIVACY_HINT`, which was written for the
 * session-personalization box and ends „užtenka pomėgių" — sound advice when the
 * app is asking you to describe your child's interests, and nonsense over a
 * support form, where hobbies are the last thing anybody wants. Reusing it read
 * as a warning copied from somewhere else, because it was.
 *
 * The split matters more than the wording: the chat goes to an outside AI
 * provider so it can answer immediately, and the form does not — `fileSupportRequest`
 * makes no provider call at all. That makes the form the privacy-safe route
 * rather than merely the fallback, and it is worth saying so where somebody is
 * choosing between them.
 */

export const SUPPORT_CHAT_PRIVACY =
  "Kad atsakytų iškart, pokalbio tekstas keliauja išoriniam AI teikėjui. Nerašyk slaptažodžių, PIN kodo, banko duomenų ar vaiko vardo — jų mums nereikia.";

export const SUPPORT_FORM_PRIVACY =
  "Formą perskaito tik žmogus — AI jos nemato. Slaptažodžių ir banko duomenų vis tiek nerašyk: jų niekada neprašome.";

/** What travels with a message either way. Shown, not hidden: it is the
 *  difference between „neveikia" and something an admin can act on. */
export const SUPPORT_ATTACHED_NOTE =
  "Pridedame automatiškai: kuriame puslapyje buvai, tavo vaidmenį, naršyklę ir naujausią programos klaidą, jei tokia ką tik buvo. Vardų ir slaptažodžių nepridedame.";
